"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackColors = void 0;
exports.feedbackColors = {
    danger: "red",
    success: "green",
    warning: "yellow",
    info: "blue",
};
